<template>
  <v-app>
    <div v-if="userIsAuthenticated" >
      <v-toolbar
        v-if="toggleMap"
        color="info"
        class="info"
        app
        dense
        elevation-6
      >
        <spacer></spacer>
        <v-btn
          @click.stop="toggleMap =!toggleMap"
          color="info black--text"
        >
          <span>{{ shortTitle }}</span>
        </v-btn>
        <v-divider></v-divider>
        <v-btn
          class="minbut"
          :style="`background:`+ colorA +`;`"
        >
          {{ minuteA }}
        </v-btn>
        <v-btn
          class="minbut"
          :style="`background:`+ colorB +`;`"
        >
          {{ minuteB }}
        </v-btn>
        <v-btn
          class="minbut"
          :style="`background:`+ colorC +`;`"
        >
          {{ minuteC }}
        </v-btn>
        <v-btn
          class="minbut"
          :style="`background:`+ info +`;`"
        >
           from {{ schTitle }} || travel type: {{ type }}
        </v-btn>
        <v-divider></v-divider>
           {{ setPixel }}px <!--~ {{ pickedBaseMap }} basemap-->
        <v-divider></v-divider>
      </v-toolbar>
      <v-toolbar
        v-if="!toggleMap"
        color="info"
        class="info"
        app
        dense
        elevation-6
      >
        <v-toolbar-side-icon @click.stop="sideNav = !sideNav"></v-toolbar-side-icon>
        <v-tooltip right dark color="black" close-delay="100">
          <v-btn
            @click.stop="toggleMap =!toggleMap"
            color="info black--text"
            slot="activator"
          >
            decaPodVT
          </v-btn>
        <span>{{ longTitle }}</span>
        </v-tooltip>
        <v-divider></v-divider>
        <v-tooltip right color="black" close-delay="300">
          <v-btn
            slot="activator"
            color='info black--text'
            small
            :to="'/selectorindex'"
          >
            {{ schTitle }}
          </v-btn>
        <span>Click to select a point of interest or school.</span>
        </v-tooltip>
        <v-tooltip left color="black" close-delay="100">
          <v-btn slot="activator"
            small
            flat
            color="info"
            :to="'/about'"
          >
            <v-icon color="black">info</v-icon>
          </v-btn>
        <span>About</span>
        </v-tooltip>
        <v-tooltip left color="black" close-delay="100">
          <v-btn slot="activator"
            small
            flat
            color="info"
            :to="'/profile'"
          >
            <v-icon color="black">person</v-icon>
          </v-btn>
        <span>Profile -- Coming Soon!</span>
        </v-tooltip>
        <v-tooltip left color="black" close-delay="100">
          <v-btn slot="activator"
            small
            flat
            color="info"
            :to="'/schoolindex'"
          >
            <v-icon color="black">school</v-icon>
          </v-btn>
        <span>School Index</span>
        </v-tooltip>
        <v-tooltip left color="black" close-delay="100">
          <v-btn slot="activator"
            small
            flat
            color="info"
            :to="'/poiindex'"
          >
            <v-icon color="black">mood</v-icon>
          </v-btn>
        <span>Point of Interest Index</span>
        </v-tooltip>
        <v-tooltip left color="black" close-delay="100">
          <v-btn slot="activator"
            small
            flat
            color="info"
            :to="'/pixelpicker'"
          >
            <v-icon color="black">graphic_eq</v-icon>
          </v-btn>
        <span>Pixel Equalizer</span>
        </v-tooltip>
        <v-tooltip left color="black" close-delay="300">
          <v-btn slot="activator" dark color="red black--text" small :to="'/inverter'" v-if="invertStatus === true" >colorize</v-btn>
        <span>Click to toggle between colorized or greyscale-inverted isochronic maps.</span>
        </v-tooltip>
        <v-tooltip right color="black" close-delay="300">
          <v-btn  slot="activator" color="grey darken-3 info--text" small :to="'/inverter'" v-if="invertStatus === false"> make greyscale</v-btn>
        <span>Click to toggle between colorized or greyscale-inverted isochronic maps.</span>
        </v-tooltip>
        <!--v-tooltip left color="black" close-delay="300">
          <v-btn slot="activator" flat disabled :to="'/basepicker'" color="red" >{{ pickedBaseMap }}</v-btn>
        <span>Select a basemap (under construction)</span>
        </v-tooltip-->
        <!--v-tooltip left color="black" close-delay="300">
          <v-btn slot="activator" flat :to="'/cluster'" v-if="clusterStatus === false" outline color="grey" >clusters</v-btn>
        <span>Coming soon!</span>
        </v-tooltip-->
        <v-tooltip left color="black" close-delay="100">
          <v-btn slot="activator"
            small
            flat
            color="info"
            :to="'/'"
          >
            <v-icon color="black">home</v-icon>
          </v-btn>
        <span>home</span>
        </v-tooltip>
        <!--v-tooltip left color="black" close-delay="100">
          <v-btn slot="activator"
            small
            disabled
            flat
            color="info"
            :to="'/geolocate'"
          >
            <v-icon color="black">gps_fixed</v-icon>
          </v-btn>
        <span>geolocate</span>
        </v-tooltip-->
        <!--v-tooltip left color="black" close-delay="100">
          <v-btn
            slot="activator"
            small
            flat
            color="info"
            :to="'/mapboard'"
          >
            <v-icon color="black">map</v-icon>
          </v-btn>
        <span>even more basemaps</span>
        </v-tooltip-->
        <v-divider></v-divider>
        <v-tooltip left color="black" close-delay="100">
          <v-btn slot="activator"
            small
            flat
            color="info"
            @click="onLogout"
          >
            <v-icon color="black">exit_to_app</v-icon>
          </v-btn>
        <span>Logout</span>
        </v-tooltip>
      </v-toolbar>
      <v-layout row wrap v-if="!toggleMap">
          <v-navigation-drawer class="info" fixed hide-overlay enable-resize-watcher temporary v-model="sideNav" mini-variant elevation-6>
            <v-tooltip right color="black" close-delay="100">
              <v-btn slot="activator"
                color="info"
                :to="'/pixelpicker'"
                >
                {{ setPixel }}
              </v-btn>
              <span>
                Identify/select the pixel density of isochrone.
              </span>
            </v-tooltip>
            <v-divider></v-divider>
            <v-tooltip right color="black" close-delay="100">
              <v-btn slot="activator"
                :to="'/timepicker'"
                color="five"
                >
                {{ minute5 }}
              </v-btn>
              <span>
                Confirming 5-minute isochrone ring and its color; press to select the isochrone ring(s)
              </span>
            </v-tooltip>
            <v-tooltip right color="black" close-delay="100">
              <v-btn slot="activator"
                :to="'/timepicker'"
                color="ten"
                >
                {{ minute10 }}
              </v-btn>
              <span>
                Confirming 10-minute isochrone ring and its color; press to select the isochrone ring(s)
              </span>
            </v-tooltip>
            <v-tooltip right color="black" close-delay="100">
              <v-btn slot="activator"
                :to="'/timepicker'"
                color="fifteen"
                >
                {{ minute15 }}
              </v-btn>
              <span>
                Confirming 15-minute isochrone ring and its color; press to select the isochrone ring(s)
              </span>
            </v-tooltip>
            <v-tooltip right color="black" close-delay="100">
              <v-btn slot="activator"
                :to="'/timepicker'"
                color="twenty"
                >
              {{ minute20 }}
              </v-btn>
              <span>
                Confirming 20-minute isochrone ring and its color; press to select the isochrone ring(s)
              </span>
            </v-tooltip>
            <v-tooltip right color="black" close-delay="100">
              <v-btn slot="activator"
                :to="'/timepicker'"
                color="twentyfive"
                >
                {{ minute25 }}
              </v-btn>
              <span>
                Confirming 25-minute isochrone ring and its color; press to select the isochrone ring(s)
              </span>
            </v-tooltip>
            <v-tooltip right color="black" close-delay="100">
              <v-btn slot="activator"
                :to="'/timepicker'"
                color="thirty"
                >
                {{ minute30 }}
              </v-btn>
              <span>
                Confirming 30-minute isochrone ring and its color; press to select the isochrone ring(s)
              </span>
            </v-tooltip>
            <v-tooltip right color="black" close-delay="100">
              <v-btn slot="activator"
                :to="'/timepicker'"
                color="thirtyfive"
                >
                {{ minute35 }}
              </v-btn>
              <span>
                Confirming a 35-minute or higher isochrone ring and its color; press to select the isochrone ring(s)
              </span>
            </v-tooltip>
            <v-divider></v-divider>
            <v-tooltip right color="black" close-delay="100">
              <v-btn slot="activator"
                :to="'/typepicker'"
                class="typeBut"
                >
                <v-icon small> {{ typeIcon }}</v-icon>
              </v-btn>
              <span>
                Confirming travel-type; press to change
              </span>
            </v-tooltip>
            <v-divider></v-divider>
          </v-navigation-drawer>
          <!--v-navigation-drawer class="info" fixed hide-overlay enable-resize-watcher temporary v-model="rightNav" max-width="32px" right elevation-6>
            <v-list class="pa-4">
              <v-list-tile avatar>
                <v-list-tile-avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Basemaps</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-menu bottom left>
            <v-btn icon slot="activator">
              <v-icon>more_vert</v-icon>
              Funky
            </v-btn>
            <v-list>
              <v-list-tile v-for="baseOption in Funky" :key="baseOption" @click="pickBase(baseOption)">
                <v-list-tile-title>{{ baseOption }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <v-btn icon slot="activator">
              <v-icon>more_vert</v-icon>
              Slick
            </v-btn>
            <v-list>
              <v-list-tile v-for="baseOption in Slick" :key="baseOption" @click="pickBase(baseOption)">
                <v-list-tile-title>{{ baseOption }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <v-btn icon slot="activator">
              <v-icon>more_vert</v-icon>
              Slick
            </v-btn>
            <v-list>
              <v-list-tile v-for="baseOption in Techno" :key="baseOption" @click="pickBase(baseOption)">
                <v-list-tile-title>{{ baseOption }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <v-btn icon slot="activator">
              <v-icon>more_vert</v-icon>
              Slick
            </v-btn>
            <v-list>
              <v-list-tile v-for="baseOption in Vermont" :key="baseOption" @click="pickBase(baseOption)">
                <v-list-tile-title>{{ baseOption }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <v-btn icon slot="activator">
              <v-icon>more_vert</v-icon>
              Slick
            </v-btn>
            <v-list>
              <v-list-tile v-for="baseOption in Outdoors" :key="baseOption" @click="pickBase(baseOption)">
                <v-list-tile-title>{{ baseOption }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          </v-navigation-drawer-->
          <v-flex xs12 align-center>
            <router-view></router-view>
          </v-flex>
      </v-layout>
      <v-layout class="hundred" align-center v-if="toggleMap">
        <map-board></map-board>
      </v-layout>
    </div>
    <div v-else>
      <not-signedin></not-signedin>
    </div>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      toggleMap: false,
      space: '  ',
      info: '#F0E9D8',
      sideNav: false,
      rightNav: false
      /*
      Funky: ['Vintage', 'Ice Cream', 'Desert planet', 'whaam!'],
      Slick: ['Standard', 'North Star', 'Scenic', 'Town and Country', 'Basic Vector'],
      Techno: ['Decimal', 'Terminal'],
      Vermont: ['VT Town Boundaries', 'Red Pins'],
      Outdoors: ['Outdoors Vector', 'Satellite Vector', 'Satellite Streets Vector'],
      Leaflet: ['Hydda', 'Toner', 'Watercolor']
      */
    }
  },
  computed: {
    pickedBaseMap () {
      return this.$store.getters.baseOption
    },
    type () {
      return this.$store.getters.type
    },
    typeIcon () {
      return this.$store.getters.typeIcon
    },
    minuteA () {
      return this.$store.getters.minuteA
    },
    minuteB () {
      return this.$store.getters.minuteB
    },
    minuteC () {
      return this.$store.getters.minuteC
    },
    colorA () {
      return this.$store.getters.colorA
    },
    colorB () {
      return this.$store.getters.colorB
    },
    colorC () {
      return this.$store.getters.colorC
    },
    version () {
      return `v.1.0.14`
    },
    longTitle () {
      return `decaPodVT a.k.a alto.photo ` + this.version + ` ~ © Sebastian Noah Frank, Nov. 30 ` + new Date().getFullYear()
    },
    shortTitle () {
      return this.version + ` © ` + new Date().getFullYear() + ` alto.photo`
    },
    invertStatus () {
      return this.$store.getters.inverse
    },
    clusterStatus () {
      return this.$store.getters.cluster
    },
    minute5 () {
      return this.$store.getters.minutes[0]
    },
    minute10 () {
      return this.$store.getters.minutes[1]
    },
    minute15 () {
      return this.$store.getters.minutes[2]
    },
    minute20 () {
      return this.$store.getters.minutes[3]
    },
    minute25 () {
      return this.$store.getters.minutes[4]
    },
    minute30 () {
      return this.$store.getters.minutes[5]
    },
    minute35 () {
      return this.$store.getters.minutes[6]
    },
    schTitle () {
      return this.$store.getters.schoolName
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    setPixel () {
      return this.$store.getters.pixel
    }
  },
  methods: {
    onLogout () {
      this.$store.dispatch('logout')
    },
    pickBase (payload) {
      this.$store.dispatch('pickBase', payload)
      // this.$router.push('/')
    }
  }
}
</script>

<style lang="stylus">
  @import './stylus/main'
.hundred {
  width:100%;
  height:100%;
}
.fullmap{
  position: absolute;
  width:100%;
  z-index:1;
  right:0%;
  height:93%;
  top:7%;
  bottom:1%;
  background:#F0E9D8;}

.typeBut {
  width: 20px;
  height: 20px;
  background:#F0E9D8;
}
.navdrawerbtn {
  z-index:2;
}
.info {
  z-index:2;
}
.under {
  z-index:-1;
}
.minbut {
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
.btn {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border-radius: 2px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 36px;
  -webkit-box-flex: 0;
      -ms-flex: 0 1 auto;
          flex: 0 1 auto;
  font-size: 14px;
  font-weight: 500;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin: 10px 5px 5px;
  min-width: 30px;
  outline: 0;
  text-transform: none;
  text-decoration: none;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
/** Psuedo */
.btn__content:before {
  border-radius: inherit;
  color: inherit;
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  opacity: 0.12;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}
/** Content */
.btn--active .btn__content:before,
.btn:hover .btn__content:before,
.btn:focus .btn__content:before {
  background-color: currentColor;
}
.btn__content {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  border-radius: inherit;
  color: inherit;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 90%;
  -webkit-box-flex: 1;
      -ms-flex: 1 0 auto;
          flex: 1 0 auto;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin: 0 auto;
  padding: 0 15px;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
}
.btn-title {
  background: repeating-linear-gradient(10deg, #d3d3d3, #7fa995 1px, #96c79d 1px, #b7ce98 1px, #e2ba8b 1px, #dfa38d 1px, #cc8f91 1px);
}
.btn-eltit {
  background: repeating-linear-gradient(45deg, #d3d3d3, #3388ff 1px, #d3d3d3 50px);
}
.multi-repeating-linear {
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  padding-right: 15px;
  background:
      repeating-linear-gradient(190deg, rgba(255, 0, 0, 0.5) 40px,
        rgba(255, 153, 0, 0.5) 80px, rgba(255, 255, 0, 0.5) 120px,
        rgba(0, 255, 0, 0.5) 160px, rgba(0, 0, 255, 0.5) 200px,
        rgba(75, 0, 130, 0.5) 240px, rgba(238, 130, 238, 0.5) 280px,
        rgba(255, 0, 0, 0.5) 300px),
      repeating-linear-gradient(-190deg, rgba(255, 0, 0, 0.5) 30px,
        rgba(255, 153, 0, 0.5) 60px, rgba(255, 255, 0, 0.5) 90px,
        rgba(0, 255, 0, 0.5) 120px, rgba(0, 0, 255, 0.5) 150px,
        rgba(75, 0, 130, 0.5) 180px, rgba(238, 130, 238, 0.5) 210px,
        rgba(255, 0, 0, 0.5) 230px),
      repeating-linear-gradient(23deg, red 50px, orange 50px,
        yellow 75px, green 250px, blue 250px,
        indigo 300px, violet 350px, red 70px);
}
.twotone {
  background:
    -moz-linear-gradient(left, #aebcbf 0%, #6e7774 50%, #0a0e0a 51%, #0a0809 100%); /* FF3.6-15 */
    -webkit-linear-gradient(left, #aebcbf 0%,#6e7774 50%,#0a0e0a 51%,#0a0809 100%); /* Chrome10-25,Safari5.1-6 */
    linear-gradient(to right, #aebcbf 0%,#6e7774 50%,#0a0e0a 51%,#0a0809 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}
</style>



// WEBPACK FOOTER //
// src/App.vue